module.exports = __webpack_public_path__ + "img/ico-ayuda-y-soporte.55a9c443.png";